var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.264,64.264c-8.968,8.968-23.56,8.968-32.527,0c-3.301-3.302-5.467-7.431-6.321-11.919l2.734,2.247 c0.372,0.307,0.821,0.455,1.269,0.455c0.578,0,1.151-0.249,1.546-0.73c0.701-0.854,0.578-2.113-0.276-2.814l-6.388-5.25 c-0.854-0.702-2.114-0.579-2.815,0.276l-5.249,6.388c-0.701,0.854-0.578,2.113,0.276,2.814c0.372,0.307,0.822,0.455,1.269,0.455 c0.578,0,1.151-0.249,1.546-0.73l2.116-2.576c0.972,5.354,3.534,10.283,7.464,14.212c5.264,5.264,12.178,7.896,19.092,7.896 s13.828-2.632,19.092-7.896c0.781-0.781,0.781-2.047,0-2.828S65.045,63.482,64.264,64.264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.487,40.269c-0.852-0.7-2.112-0.579-2.814,0.276l-2.117,2.577c-0.972-5.354-3.534-10.283-7.464-14.213 C61.992,23.809,55.212,21,48,21s-13.992,2.809-19.092,7.908c-0.781,0.781-0.781,2.047,0,2.828c0.78,0.781,2.048,0.781,2.828,0 C36.081,27.392,41.856,25,48,25s11.92,2.392,16.264,6.736c3.301,3.301,5.467,7.431,6.321,11.918l-2.734-2.246 c-0.852-0.7-2.112-0.579-2.814,0.276c-0.701,0.853-0.578,2.114,0.275,2.815l6.388,5.248c0.372,0.307,0.821,0.455,1.269,0.455 c0.577,0,1.15-0.249,1.546-0.73l5.249-6.388C80.464,42.23,80.341,40.97,79.487,40.269z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5f126faa6dbb94ce5cef19194e75f62b.svg";
export { ForwardRef as ReactComponent };